const student = [
    {
        text: 'colleagues',
        media: 'Morgan_Kelly',
        type: 'image',
        desktop: {
            offset: 120,
            degree: 0
        },
        mobile: {
            offset: 100,
            degree: 275
        },
        story: {
            id: 1
        }
    }, {
        text: 'communities',
        media: 'Jessica_Hudson',
        type: 'image',
        desktop: {
            offset: 15,
            degree: 90
        },
        mobile: {
            offset: 15,
            degree: 70
        },
        story: {
            id: 2
        }
    }, {
        offset: 110,
        text: 'clients',
        media: 'Patrick_McCormack',
        type: 'image',
        desktop: {
            offset: 110,
            degree: -80
        },
        mobile: {
            offset: 0,
            degree: 70
        },
        story: {
            id: 3
        }
    }
]

const experienced = [
    {
        text: 'colleagues',
        media: 'Morgan_Kelly',
        type: 'image',
        desktop: {
            offset: 120,
            degree: 0
        },
        mobile: {
            offset: 100,
            degree: 280
        },
        story: {
            id: 1
        }
    }, {
        text: 'communities',
        media: 'Jessica_Hudson',
        type: 'image',
        desktop: {
            offset: 15,
            degree: 90
        },
        mobile: {
            offset: 15,
            degree: 70
        },
        story: {
            id: 2
        }
    }, {
        offset: 110,
        text: 'clients',
        media: 'Patrick_McCormack',
        type: 'image',
        desktop: {
            offset: 110,
            degree: -80
        },
        mobile: {
            offset: 0,
            degree: 70
        },
        story: {
            id: 3
        }
    }
]

export default {
    student,
    experienced
}